import * as React from 'react';
import { EditState, BaseRouteProps } from '../../../interfaces';
import { ScoreCardGroupCharacteristic } from '../../../models';
import { ScoreCardGroupCharacteristicDataService } from '../../../services';
import { NavLink } from 'react-router-dom';
import { TopNavMenu } from '../../navigation/TopNavMenu';
import { ScoreCardGroupCharacteristicForm } from './ScoreCardGroupCharacteristicForm';
import { LoadingIndicator } from '../../../components';
import { UserStore } from '../../../stores';
import { inject, observer } from 'mobx-react';
import { computed } from 'mobx';

interface ScoreCardCharacteristicEditProps extends BaseRouteProps<{groupId: number, id: number}> {
    UserStore?: UserStore;
}

interface ScoreCardGroupCharacteristicEditState extends EditState<ScoreCardGroupCharacteristic> {
    loading: boolean;
}

@inject('UserStore') @observer
export class ScoreCardGroupCharacteristicEdit extends React.Component<ScoreCardCharacteristicEditProps, ScoreCardGroupCharacteristicEditState> {
    private scoreCardGroupCharacteristicDataService = new ScoreCardGroupCharacteristicDataService(this.props.notificationService);

    @computed get userLanguage() {
        return this.props.UserStore!.userInfo.language;
    }

    constructor(props: ScoreCardCharacteristicEditProps) {
        super(props);

        this.state = {
            originalEntity: undefined,
            loading: false
        };

        this.save = this.save.bind(this);
    }

    public componentDidMount() {
        const id = this.props.match.params.id;

        if (id) {
            this.scoreCardGroupCharacteristicDataService.get(id).then((scoreCardGroupCharacteristic: ScoreCardGroupCharacteristic) => {
                this.setState({ originalEntity: scoreCardGroupCharacteristic });
            }).catch((response) => {
                this.props.history.push({
                    pathname: '/error',
                    state: {
                        code: response.status,
                        entityType: 'Score Card Characteristic'
                    }
                });
            });
        }
    }

    public render() {
        if (!this.state.originalEntity || this.state.loading) {
            return <LoadingIndicator />;
        }

        return (
            <div>
                <TopNavMenu open={true} />

                <div className="content-header">
                    <div className="content-container">
                        <div className="title">
                            <NavLink to={`/scorecards/${this.state.originalEntity.scoreCardGroup.scoreCardID}/groups/${this.props.match.params.groupId}`}>
                                <span className="glyphicon glyphicon-triangle-left" />
                            </NavLink>
                            &nbsp; 
                            Edit Score Card Group Characteristic
                        </div>
                    </div>
                </div>

                <div className="content-body">
                    <div className="content-container">
                        <ScoreCardGroupCharacteristicForm defaultValues={this.state.originalEntity} submit={(e: any) => this.save(e)} />
                    </div>
                </div>
            </div>);
    }

    private save(values: any) {
        this.scoreCardGroupCharacteristicDataService.update(values);
    }
}


// WEBPACK FOOTER //
// ./src/components/scoreCard/scoreCardGroupCharacteristic/ScoreCardGroupCharacteristicEdit.tsx